import React, { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
const FAQ: React.FC = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    question: 'Hur fungerar VeeloBooster?',
    answer: 'VeeloBooster arbetar på fyra fronter: 1) Ökar blodflödet till corpora cavernosa för kraftigare erektioner, 2) Höjer testosteronnivåerna för ökad sexlust, 3) Främjar cellregenerering för maximal expansion, 4) Ger extra energi för ökad uthållighet. Alla ingredienser är naturliga och kliniskt testade.'
  }, {
    question: 'Hur snabbt märker man effekt?',
    answer: 'Många användare rapporterar förbättringar redan efter första veckan, men för bästa resultat rekommenderar vi regelbunden användning i minst 2-4 veckor. Varje kropp är unik, så effekterna kan variera från person till person.'
  }, {
    question: 'Finns biverkningar?',
    answer: 'VeeloBooster är skapad enbart av naturliga ingredienser som använts i tusentals år utan problem eller kontraindikationer. Formeln har noga testats i laboratorium och är säker att använda. Som med alla kosttillskott kan individuella reaktioner förekomma.'
  }, {
    question: 'Är VeeloBooster som Viagra?',
    answer: 'Nej, till skillnad från Viagra som är ett läkemedel, är VeeloBooster ett helt naturligt kosttillskott. Medan Viagra ger omedelbar men tillfällig effekt, arbetar VeeloBooster för att förbättra din sexuella hälsa på lång sikt genom att stärka din naturliga förmåga.'
  }, {
    question: 'Passar VeeloBooster för alla män?',
    answer: 'VeeloBooster är utvecklad för män över 18 år som vill förbättra sin sexuella prestationsförmåga. Om du har allvarliga hälsoproblem eller tar mediciner, rekommenderar vi att du konsulterar läkare innan användning.'
  }];
  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="w-full py-16 px-4 bg-[#0A1020]" data-id="element-53">
      <div className="max-w-3xl mx-auto" data-id="element-54">
        <h2 className="text-3xl font-bold mb-8 text-center" data-id="element-55">Vanliga frågor</h2>
        <div className="space-y-4" data-id="element-56">
          {faqs.map((faq, index) => <div key={index} className="bg-gray-900 rounded-lg overflow-hidden" data-id="element-57">
              <button onClick={() => toggleFaq(index)} className="flex justify-between items-center w-full p-5 text-left font-medium" data-id="element-58">
                <span data-id="element-59">{faq.question}</span>
                {openIndex === index ? <ChevronUpIcon className="w-5 h-5 flex-shrink-0" data-id="element-60" /> : <ChevronDownIcon className="w-5 h-5 flex-shrink-0" data-id="element-61" />}
              </button>
              {openIndex === index && <div className="p-5 pt-0 text-gray-300" data-id="element-62">
                  <p data-id="element-63">{faq.answer}</p>
                </div>}
            </div>)}
        </div>
        <div className="mt-8 text-center" data-id="element-64">
          <a href="https://www.fasttrack39.com/Q2F67GN8/2K64K71K/" className="inline-flex px-8 py-4 bg-[#0EB7FF] hover:bg-[#0EA7EF] text-black font-semibold rounded-md text-lg transition-all" data-id="element-65">
            Prova VeeloBooster idag!
          </a>
        </div>
      </div>
    </section>;
};
export default FAQ;